import { Button, Form, TextField } from '@ui';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Yup from 'yup';
import usePhonePrefix from '../../../helpers/use-phone-prefix';
import { ModalCopySC } from '../../modal/modal.styled';
import { FormSC } from './patients-modals.styled';

export type TFormValues = {
  name: string;
  surname: string;
  phone: string;
};

type TProps = {
  onSubmit(values: TFormValues): void;
};

const formSchema = Yup.object().shape({
  name: Yup.string().required('validation.required'),
  surname: Yup.string().required('validation.required'),
  phone: Yup.string()
    .required('validation.required')
    .test('phone', 'validation.phone_format', function (v: any) {
      if (v) {
        const phone = parsePhoneNumberFromString(v);
        return phone?.isValid() || false;
      }
      return false;
    }),
});

const AddModal: React.FC<TProps> = ({ onSubmit }) => {
  const phoneNumberPrefix = usePhonePrefix();

  const { formatMessage } = useIntl();

  const initialValues: TFormValues = {
    name: '',
    surname: '',
    phone: phoneNumberPrefix + ' ',
  };

  const [, formOptions] = Form.useForm({
    initialValues,
    onSubmit,
    validationSchema: formSchema,
  });

  return (
    <FormSC {...formOptions}>
      <ModalCopySC>
        <FormattedMessage id="patients_add_modal.copy" />
      </ModalCopySC>
      <Form.Field name="name" label={formatMessage({ id: 'patients_add_form.name' })} required>
        <TextField placeholder={formatMessage({ id: 'patients_add_form.placeholder' })} />
      </Form.Field>
      <Form.Field
        name="surname"
        label={formatMessage({ id: 'patients_add_form.surname' })}
        required
      >
        <TextField placeholder={formatMessage({ id: 'patients_add_form.placeholder' })} />
      </Form.Field>
      <Form.Field name="phone" label={formatMessage({ id: 'patients_add_form.phone' })} required>
        <TextField placeholder={formatMessage({ id: 'patients_add_form.placeholder' })} />
      </Form.Field>
      <Form.Custom>
        {(f) => (
          <Button type="submit" style={{ marginTop: 16 }} rightArrow>
            {formatMessage({ id: 'pateints_add_form.submit' })}
          </Button>
        )}
      </Form.Custom>
    </FormSC>
  );
};

export default AddModal;
